import * as Yup from 'yup';
import i18n from 'i18n-js';

export const ruleSchema = (rule, allowAdditionalMilesEnabled) => {
  return Yup.object().shape({
    pricing_type: Yup.object().required(i18n.t('common.required_field')),
    invoice_item_type_id: Yup.string().required(i18n.t('common.required_field')),
    category: Yup.string(),
    description: Yup.string(),
    all_time: Yup.boolean(),
    start_day: Yup.number().when('all_time', {
      is: (val) => val === false,
      then: Yup.number().required(i18n.t('common.required_field')),
    }),
    end_week: Yup.boolean(),
    end_day: Yup.number().when(['all_time', 'end_week'], (all_time, end_week) => {
      return !all_time && !end_week
        ? Yup.number().required(i18n.t('common.required_field'))
        : Yup.number();
    }),
    start: Yup.number().when('all_time', {
      is: (val) => val === false,
      then: Yup.number().required(i18n.t('common.required_field')),
    }),
    end: Yup.number().when('all_time', {
      is: (val) => val === false,
      then: Yup.number().required(i18n.t('common.required_field')),
    }),
    unit_price: Yup.number()
      .min(0, i18n.t('common.min_0'))
      .required(i18n.t('common.required_field')),
    rounding_strategy: Yup.string(),
    extra_arguments: Yup.object().shape({
      financing_factor: Yup.number()
        .nullable()
        .when('pricing_type', {
          is: (val) => val?.name === 'SUBSCRIPTIONPERIODFACTOR',
          then: Yup.number()
            .required(i18n.t('common.required_field'))
            .min(0, i18n.t('common.min_0')),
        }),
      max_time_to_bill: Yup.number()
        .nullable()
        .when('pricing_type', {
          is: (val) => val?.name === 'RETURNEDLATE',
          then: Yup.number()
            .required(i18n.t('common.required_field'))
            .min(0, i18n.t('common.min_0')),
        }),
      grace_period: Yup.number()
        .nullable()
        .when('pricing_type', {
          is: (val) => val?.name === 'RETURNEDLATE',
          then: Yup.number()
            .required(i18n.t('common.required_field'))
            .min(0, i18n.t('common.min_0')),
        }),
      out_of_state: Yup.number()
        .nullable()
        .when('pricing_type', {
          is: (val) => val?.name === 'SUBSCRIPTIONDELIVERYSTATE',
          then: Yup.number()
            .required(i18n.t('common.required_field'))
            .min(0, i18n.t('common.min_0')),
        }),
      level_pct: Yup.number()
        .nullable()
        .when('pricing_type', {
          is: (val) => val?.name === 'RETURNENERGYLEVEL',
          then: Yup.number()
            .required(i18n.t('common.required_field'))
            .min(0, i18n.t('common.min_0')),
        }),
      operator: Yup.string()
        .nullable()
        .when('pricing_type', {
          is: (val) => val?.name === 'RETURNENERGYLEVEL',
          then: Yup.string().required(i18n.t('common.required_field')),
        }),
      tiers: Yup.object().nullable(),
      ...(allowAdditionalMilesEnabled
        ? {
            distance_allowance: Yup.number()
              .min(0, i18n.t('common.min_0'))
              .when('pricing_type', {
                is: (val) => val?.name === 'DISTANCEDRIVEN',
                then: Yup.number().required(i18n.t('common.required_field')),
              }),
          }
        : {}),
      timeframe: Yup.string(),
      acceptable_excess: Yup.number().min(0, i18n.t('common.min_0')),
    }),
  });
};
